import moengage from '@moengage/web-sdk'

type Config = {
    appId: string
    cluster: string
    projectId?: string
    debug?: boolean
}

function waitForMoeLoaded(timeout = 5000): Promise<void> {
  return new Promise((resolve, reject) => {
    if (moengage.isMoeLoaded()) return resolve()
    const start = Date.now()
    const interval = setInterval(() => {
      if (moengage.isMoeLoaded()) {
        clearInterval(interval)
        resolve()
      } else if (Date.now() - start > timeout) {
        clearInterval(interval)
        reject(new Error('MoEngage SDK load timeout'))
      }
    }, 100)
  })
}

export const initMoengage = (config: Config) => {
  const { appId, cluster, debug } = config

  moengage.initialize({
    app_id: appId,
    cluster: cluster,
    debug_logs: debug ? 1 : 0,
    enableSPA: true,
  })
}

// 로그인 시 사용자 고유 ID 설정
export async function setUserId(uniqueId: string, extraIdentities?: Record<string, any>) {
  await waitForMoeLoaded()
  await moengage.identifyUser(uniqueId)

  if (extraIdentities) {
    await moengage.identifyUser(extraIdentities)
  }
}

// 사용자 속성 설정
export async function setUserAttrs(attrs: Record<string, any>) {
  await waitForMoeLoaded()
  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === null) continue
    await moengage.add_user_attribute(key, value)
  }
}

// 페이지 뷰 추적
export async function trackPageView(pageName?: string, attrs?: Record<string, any>) {
  await waitForMoeLoaded()
  await moengage.track_page_view()

  if (pageName) {
    await moengage.track_event(`${pageName}_page_view`, attrs)
  }
}

// 이벤트 추적
export async function trackEvent(name: string, attrs?: Record<string, any>) {
  await waitForMoeLoaded()
  await moengage.track_event(name, attrs)
}